var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup350(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22898 3.11801C10.3759 5.34139 11.8579 7.37516 13.623 9.14801C14.8047 10.3685 15.7517 11.7959 16.417 13.359C16.9507 14.6459 17.0959 16.0609 16.8345 17.4293C16.573 18.7977 15.9166 20.0595 14.946 21.059C14.2363 21.9051 13.3462 22.5816 12.341 23.0389C11.3359 23.4962 10.2411 23.7228 9.13694 23.702C7.76016 23.7071 6.40799 23.3382 5.22459 22.6346C4.04118 21.9309 3.07101 20.919 2.41795 19.707C0.677947 16.723 1.18896 13.816 3.15696 11.153C4.51096 9.32102 6.08004 7.653 7.48704 5.853C8.11321 4.97113 8.69456 4.05832 9.22898 3.11801Z",
    fill: "#9FDDFF",
    stroke: "#417EBA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3879 6.11801C15.0999 5.25101 15.544 4.72999 16.063 4.02899C16.582 3.32799 17.0389 2.604 17.5239 1.888C17.9019 2.473 18.244 3.07601 18.656 3.62701C19.508 4.77101 20.4561 5.84501 21.2561 7.02701C21.9808 7.96278 22.362 9.11908 22.3359 10.3023C22.3099 11.4856 21.8781 12.624 21.113 13.527C20.5171 14.1406 19.8724 14.7048 19.1851 15.214C19.3095 14.4431 19.2721 13.6548 19.0757 12.8991C18.8793 12.1434 18.528 11.4367 18.0439 10.824C16.3709 8.45901 15.1169 7.70601 14.3879 6.11801Z",
    fill: "#9FDDFF",
    stroke: "#417EBA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup350);
export default __webpack_public_path__ + "static/media/Group 350.e7e04708dc4f71f43052e48c0a68f681.svg";
export { ForwardRef as ReactComponent };